// src/pages/account/AfricanTransactionDetails.jsx
import React from 'react';
import TransactionDetails from '../TransactionDetails';

const AfricanTransactionDetails = () => {
  return <TransactionDetails locationKey="african" />;
};

export default AfricanTransactionDetails;